import * as moment from 'moment';
import { ApiDatesOfServiceRequest, ApiDatesOfServiceResponse, DosResult, HttpUrlParams } from 'src/app/core/models';
import { reorderDt } from './order.mock';

const dosDt = reorderDt;
const dosDt2 = moment(reorderDt).clone().add(1, 'day').format();

/////////////////////////////////////////////////////////
// Either case will force hiding billing info when true:
const undefinedDates = false;
const differentTSDs = false;
/////////////////////////////////////////////////////////

let numDosCalls = 0;
const initialDosResult = DosResult.Consent;

export const getDatesOfService = (
  urlParams: HttpUrlParams | undefined,
  body: ApiDatesOfServiceRequest
): ApiDatesOfServiceResponse => {
  numDosCalls++;
  let dosResult = initialDosResult;
  let earliestOrderCanShip = differentTSDs ? dosDt2 : dosDt;

  if (numDosCalls > 1) {
    const daysOnHand = body.items.map((i) => i.daysOnHand).filter((doh) => !!doh || doh === 0) as number[];
    const maxDoh = Math.max(...daysOnHand.filter((doh) => doh && doh > 14));

    if (daysOnHand.some((doh) => doh && doh > 24)) {
      dosResult = DosResult.End;
      earliestOrderCanShip = moment(earliestOrderCanShip)
        .clone()
        .add(maxDoh - 14, 'days')
        .format();
    } else if (daysOnHand.some((doh) => doh && doh > 14)) {
      dosResult = DosResult.Edit;
      earliestOrderCanShip = moment(earliestOrderCanShip)
        .clone()
        .add(maxDoh - 14, 'days')
        .format();
    } else {
      dosResult = DosResult.Consent;
    }
  }

  return {
    dosResult,
    earliestOrderCanShip,
    items: body.items.map((i) => ({
      itemId: i.itemId,
      uiId: i.uiId,
      shippingFrequency: 1,
      calculatedDos: dosDt,
      lastDos: dosDt,
      targetedShipDate: differentTSDs ? dosDt2 : dosDt,
      consentDate: undefinedDates ? undefined : moment(dosDt).subtract(1, 'month').format(),
    })),
  };
};
